import { defineStore } from 'pinia'

export const useGlobalStore = defineStore({
    id: 'global',
    state: () => ({
        loading: false,
        openedDialogs: [],
        sharedData: null
    }),
    actions: {
        toggleOn() {
            this.loading = true
        },
        toggleOff() {
            this.loading = false
        },
        registerDialog(dialog) {
            this.openedDialogs.push(dialog)
        },
        removeDialog(dialog) {
            const indexToRemove = this.openedDialogs.indexOf(dialog)
            if (indexToRemove !== -1) {
                this.openedDialogs.splice(indexToRemove, 1)
            }
        },
        closeDialogs() {
            this.openedDialogs.forEach(d => d.close({ 'causedByLogout': true }))
            this.openedDialogs = []
        }
    }
})